import { Injector, OnInit, OnDestroy, Directive } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionStorage } from 'ngx-webstorage';

import { BaseComponent } from './base-component';
import { BreadcrumbDataService } from '../services/breadcrumb-data.service';

@Directive()
export abstract class ListBaseComponent extends BaseComponent implements OnInit, OnDestroy {

  pageSize: number;
  search: any = {};
  pageSizes: Array<any> = [
    { name: '10', value: 10 },
    { name: '25', value: 25 },
    { name: '50', value: 50 },
    { name: 'All', value: 0 }
  ];
  data: {
    data: Array<any>,
    totalItems: number,
    itemsPerPage: number,
    title: string
  };
  loading = false;

  protected defaultSearch: any;
  protected route: ActivatedRoute;
  protected breadcrumbService: BreadcrumbDataService;
  private bredcrumbChangeSubscription: Subscription;

  constructor(
    injector: Injector) {
    super(injector);

    this.route = injector.get(ActivatedRoute);
    this.breadcrumbService = injector.get(BreadcrumbDataService);

    const router = injector.get(Router);
    router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
  }

  private checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    } else if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }

  ngOnInit() {
    this.search = {
      page: 1,
      pageSize: 10,
      ...this.defaultSearch,
      ...this.route.snapshot.queryParams
    };

    //  If page size item does not exist, add it
    if (!this.pageSizes.find(m => m.value === this.search.pageSize)) {
      this.pageSizes.push({
        name: this.search.pageSize,
        value: this.search.pageSize
      });
    }

    this.route.data.subscribe((data: any) => {
      this.data = data.entities;
    });
    this.data = this.route.snapshot.data.entities;

    this.bredcrumbChangeSubscription = this.breadcrumbService.onChanges.subscribe((t) => {
      this.onBreadcrumbUpdated(this.breadcrumbService);
    });
    this.onBreadcrumbUpdated(this.breadcrumbService);
  }

  ngOnDestroy() {
    if (this.bredcrumbChangeSubscription) {
      this.bredcrumbChangeSubscription.unsubscribe();
    }
  }

  searchAction(e: any) {
    e.preventDefault();
    this.reload();
  }

  searchReset() {
    this.search = {
      page: 1,
      pageSize: '10',
      ...this.defaultSearch,
    };

    this.router.navigate(['.'], { relativeTo: this.route });
  }

  reload() {
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: { ...this.route.snapshot.queryParams, ...this.search } });
  }

  protected onBreadcrumbUpdated(breadcrumbData: BreadcrumbDataService) {
  }
}
